import { render, staticRenderFns } from "./ModalAtrasos.vue?vue&type=template&id=217fdd67&"
import script from "./ModalAtrasos.vue?vue&type=script&lang=js&"
export * from "./ModalAtrasos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports